import { AuthedPage, HeaderFooterLayout } from '../app';

const Dashboard = ({ children }: { children: React.ReactElement }) => {
  return (
    <AuthedPage>
      <HeaderFooterLayout useDashboardHeader>
        <div className='mb-20 mt-1.5'>{children}</div>
      </HeaderFooterLayout>
    </AuthedPage>
  );
};

export default Dashboard;
